import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { Operaciones_Reembolso_Lista } from 'src/app/models/generic/Operaciones_Reembolso_Lista';
import { Operaciones_ReembolsoService } from 'src/app/services/operaciones_reembolso.service';
import { Listas } from 'src/app/models/generic/Listas';
import { OperacionesReembolsoActualizarComponent } from '../operaciones-reembolso-actualizar/operaciones-reembolso-actualizar.component';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { ComponentRestrictions } from 'ngx-google-places-autocomplete/objects/options/componentRestrictions';
import { GoogleMap } from '@angular/google-maps';
import { Maestros_PaisesService } from '../../services/maestros_paises';
import { Maestro_Paises } from 'src/app/models/generic/Maestro_Paises';
import { Maestros_CiudadesService } from 'src/app/services/maestros_ciudades';
import { Maestro_Ciudades_Ubicacion } from 'src/app/models/generic/Maestro_Ciudades_Ubicacion';
import { Maestro_Ciudades_Ubicacion_Colores } from 'src/app/models/generic/Maestro_Ciudades_Ubicacion_Colores';
import { Ciudades_Poligonos } from '../../models/generic/Ciudades_Poligonos';

@Component({
  selector: 'operaciones-reembolso-ubicacion',
  templateUrl: './operaciones-reembolso-ubicacion.component.html',
  styleUrls: ['./operaciones-reembolso-ubicacion.component.scss']
})
export class OperacionesReembolsoUbicacionComponent implements OnInit{
  @ViewChild('appoperacionesreembolso', {static: false}) _appoperacionesreembolso: OperacionesReembolsoActualizarComponent;
  @ViewChild("placesRef") placesRef : GooglePlaceDirective;
  @ViewChild("maps") maps : GoogleMap;
  
  COBERTURA_COLOR_VERDE: string = 'VERDE';
  COBERTURA_COLOR_ROJO: string = 'ROJO';
  COLOR_COBERTURA: string = '#88FF98';
  COLOR_NOCOBERTURA: string = '#F2B5C6';
  COLOR_OPACITY: number = 0.8;
  listaCiudades: Maestro_Ciudades_Ubicacion[] = [];
  direccionSeleccionada: string = '';
  codigoPaisSeleccionada: string = '';
  codigoProvinciaSeleccionada: string = '';
  codigoCiudadSeleccionada: string = '';

  mapCenter: any;
  mapOptions: google.maps.MapOptions = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    fullscreenControl: false
  };
  zoomOption: number = 5;

  markerInfoContent = '';
  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    animation: google.maps.Animation.DROP,
  };

  options: Options;
  latitudeSelected: any;
  longitudeSelected: any;
  terminoCargarDefinicioDefecto: boolean = false;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Operaciones_ReembolsoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService,
    public maestros_PaisesService: Maestros_PaisesService,
    public maestros_CiudadesService: Maestros_CiudadesService) {
  }

  ngOnInit() {
    this.ConsultarPaisPorDefecto();
  }
  ngAfterViewInit() {
    
  }

  ConsultarPaisPorDefecto() {
    this.maestros_PaisesService.ConsultarDefecto()
      .subscribe((resp: Maestro_Paises[]) =>{
        let provinciaDefecto: string = '';
        let ciudadDefecto: string = '';
        if (resp.length > 0) {
          
          this.options = new Options();
          this.options.componentRestrictions = new ComponentRestrictions();
          this.options.componentRestrictions.country = resp[0].codigo;

          if (this.utilitariosService.VerificarContieneDatos(resp[0].latitud) && this.utilitariosService.VerificarContieneDatos(resp[0].longitud)) {
            this.mapCenter  = {
              lat: resp[0].latitud,
              lng: resp[0].longitud,
            };
          }

          if (this.utilitariosService.VerificarContieneDatosTexto(resp[0].provinciadefecto)) {
            provinciaDefecto = resp[0].provinciadefecto;
          }
          if (this.utilitariosService.VerificarContieneDatosTexto(resp[0].ciudaddefecto)) {
            ciudadDefecto = resp[0].ciudaddefecto;
          }

          this.codigoPaisSeleccionada = resp[0].codigo;
        }

        this.terminoCargarDefinicioDefecto = true;

        if (this.utilitariosService.VerificarContieneDatosTexto(provinciaDefecto) && this.utilitariosService.VerificarContieneDatosTexto(ciudadDefecto)) {
          this.ConsultarPoligonosProvincia(provinciaDefecto, ciudadDefecto);
        }
      },
      (error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
  }

  ConsultarCodigosCiudadSeleccionada(provincia: string, ciudad: string) {
    let parametrosConsulta: FormGroup = new FormGroup({
      'provincia': new FormControl(provincia),
      'ciudad': new FormControl(ciudad)
    });

    this.maestros_CiudadesService.ConsultarColorCoberturaCodigoMapa(parametrosConsulta.value)
      .subscribe((resp: Maestro_Ciudades_Ubicacion_Colores[]) =>{
        if (resp.length > 0) {
            
          for (let index = 0; index < resp.length; index++) {
            let itemConfiguracion = resp[index];
            this.CreacionPoligonoCiudad(itemConfiguracion);
          }
        }
      },
      (error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
  }

  ConsultarPoligonosProvincia(provincia: string, ciudad: string) {
    if (this.listaCiudades.filter(x => x.provincia === provincia && x.codigo === ciudad).length === 0) {
      this.maestros_CiudadesService.ConsultarColorCobertura(provincia, ciudad)
        .subscribe((resp: Maestro_Ciudades_Ubicacion_Colores[]) =>{
          if (resp.length > 0) {
            
            for (let index = 0; index < resp.length; index++) {
              let itemConfiguracion = resp[index];
              this.CreacionPoligonoCiudad(itemConfiguracion);
            }
          }
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
    }
  }

  CreacionPoligonoCiudad(itemConfiguracion: Maestro_Ciudades_Ubicacion_Colores) {
    this.codigoProvinciaSeleccionada = itemConfiguracion.provincia;
    this.codigoCiudadSeleccionada = itemConfiguracion.codigo;

    if (this.listaCiudades.filter(x => x.provincia === itemConfiguracion.provincia && x.codigo === itemConfiguracion.codigo).length === 0) {
      let itemCiudad: Maestro_Ciudades_Ubicacion = new Maestro_Ciudades_Ubicacion();

      itemCiudad.codigo = itemConfiguracion.codigo;
      itemCiudad.provincia = itemConfiguracion.provincia;
      itemCiudad.cobertura = itemConfiguracion.colorPoligono;
      itemCiudad.listaPoligono = itemConfiguracion.listaPoligono;
      itemCiudad.opcionesPoligono = {};
      if (itemCiudad.cobertura === this.COBERTURA_COLOR_VERDE) {
        itemCiudad.opcionesPoligono.fillColor = this.COLOR_COBERTURA;
        itemCiudad.opcionesPoligono.strokeColor = this.COLOR_COBERTURA;
      } else if (itemCiudad.cobertura === this.COBERTURA_COLOR_ROJO) {
        itemCiudad.opcionesPoligono.fillColor = this.COLOR_NOCOBERTURA;
        itemCiudad.opcionesPoligono.strokeColor = this.COLOR_NOCOBERTURA;
      } else {
        if (this.utilitariosService.VerificarContieneDatosTexto(itemCiudad.cobertura)) {
          itemCiudad.opcionesPoligono.fillColor = itemCiudad.cobertura;
          itemCiudad.opcionesPoligono.strokeColor = itemCiudad.cobertura;
        } else {
          itemCiudad.opcionesPoligono.fillColor = this.COBERTURA_COLOR_ROJO;
          itemCiudad.opcionesPoligono.strokeColor = this.COBERTURA_COLOR_ROJO;
        }
      }
      
      itemCiudad.opcionesPoligono.fillOpacity = this.COLOR_OPACITY;
      this.listaCiudades.push(itemCiudad);
      console.log('listaciudades', this.listaCiudades);
    }
  }

  handleAddressChange(address: Address) {
    console.log('handleAddressChange', address);

    this.zoomOption = 10;
    this.mapCenter  = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
    };
    
    let provincia: string = '';
    let ciudad: string = '';
    
    for (let index = 0; index < address.address_components.length; index++) {
      let item = address.address_components[index];
      
      if (item.types.filter(x => x === 'administrative_area_level_1').length > 0) {
        provincia = item.short_name;
      } else if (item.types.filter(x => x === 'administrative_area_level_2').length > 0) {
        ciudad = item.short_name;
      }
    }
    this.direccionSeleccionada = address.name;
    this.ConsultarCodigosCiudadSeleccionada(provincia, ciudad);
  }
  TerminoGuardarOperacionesReembolso() {
    this.menuService.CambiarComponenteActivo('OperacionesReembolsoComponent');
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  AnchoBuscador(anchoActualContenedor: number): string {
    return `${anchoActualContenedor}px`;
  }
  UbicarControlBuscador() {
    document.getElementById('buscadorGoogle').focus();
  }
  RegistrarUbicacion() {
    if (this.utilitariosService.VerificarContieneDatosTexto(this.direccionSeleccionada)) {
      this._appoperacionesreembolso.CrearAbrirModal(this.direccionSeleccionada, this.codigoPaisSeleccionada, this.codigoProvinciaSeleccionada, this.codigoCiudadSeleccionada);
    } else {
      this.utilitariosService.MensajeToast('Debe seleccionar una dirección');
    }
  }
}
